var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { css as emotionCss, cx } from 'emotion';
import { BorderlessButton } from '@citrus/button';
import { Icon } from '@citrus/icon';
import { clearButtonStyles } from '../../styles/legacy';
import { clearButtonStyles as clearButtonStylesCitrus2022, iconColor04 } from '../../styles/citron';
import { getStyleNames, getAutomation } from '@citrus/runtime';
import { useLocalization, useTheme } from '@citrus/user';
import { ClearContainer, ClearContainerFocus } from '../Textfield.styled';
import localizationMap from '../../localization';
export var ClearButton = function (_a) {
    var _b;
    var automationId = _a.automationId, disabled = _a.disabled, focus = _a.focus, id = _a.id, other = __rest(_a, ["automationId", "disabled", "focus", "id"]);
    var lang = useLocalization(localizationMap);
    var theme = useTheme();
    var emotionObj = (_b = {},
        _b[emotionCss(clearButtonStyles)] = theme.legacy,
        _b[emotionCss(clearButtonStylesCitrus2022)] = theme.citrus2022,
        _b[emotionCss({ height: 36, width: 37 })] = theme.citrus2022 && focus,
        _b);
    var classes = cx(emotionObj);
    var Container = theme.citrus2022 && focus ? ClearContainerFocus : ClearContainer;
    return (React.createElement(Container, null,
        React.createElement(BorderlessButton, __assign({}, other, getAutomation(automationId, 'clear'), { "aria-label": lang.clear, buttonType: "button", className: classes, disabled: disabled, id: id + '-clear', onBlur: function () { return undefined; }, size: "medium", styleNames: getStyleNames({ clearButtonStyles: true }) }),
            React.createElement(Icon, { "aria-label": lang.clear, color: theme.citrus2022 ? iconColor04 : undefined, name: "x", size: "small" }))));
};
